import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { Backdrop } from '../types/misc';

@Injectable({
  providedIn: 'root',
})
export class BackdropService {
  private activeOverlaySubject: BehaviorSubject<Backdrop> =
    new BehaviorSubject<Backdrop>(null);
  private activeOverlay: Backdrop = null;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.document.body.addEventListener('click', (event) => {
      if (
        this.activeOverlay &&
        (event.target as HTMLElement).tagName === 'BODY'
      ) {
        this.setOverlay(null);
      }
    });
  }

  setOverlay(type: Backdrop, lockScroll: boolean = false): void {
    if (!type && this.activeOverlay) {
      this.document.body.classList.remove(this.activeOverlay);
      this.document.body.classList.remove('overflow-hidden');
      this.activeOverlay = null;
      this.activeOverlaySubject.next(this.activeOverlay);
      return;
    }

    if (type) {
      if (this.activeOverlay) {
        this.document.body.classList.remove(this.activeOverlay);
      }
      this.document.body.classList.add(type);

      if (lockScroll) {
        this.document.body.classList.add('overflow-hidden');
      }
      this.activeOverlay = type;
    }

    this.activeOverlaySubject.next(this.activeOverlay);
  }

  getActiveOverlay$(): Observable<Backdrop> {
    return this.activeOverlaySubject.asObservable();
  }
}
